export default __webpack_public_path__ + "static/media/bg1.c87be0fb.jpg";